module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "kp-button kp-button__min btn-gray",
    on: {
      "click": function($event) {
        return _vm.checkModal();
      }
    }
  }, [_c('span', {
    staticClass: "kp-panel-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n  " + _vm._s(_vm.$t('general.actions.export').toUpperCase()) + " " + _vm._s(_vm.$t('general.labels.table').toUpperCase()) + "\n")])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-21715228!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/individual/ExportButton.vue
 ** module id = 779
 ** module chunks = 1
 **/